export default {
    apiURLPrefix: "/api"
};